module.exports = __webpack_public_path__ + "img/img_student6.503e5a3d.png";